import { useMap } from "../../../context/map";
import { useRoot } from "../../../context/root";

export const useGoToDefaultView = () => {
  const { mapContext } = useMap()
  const { mapRefresh, rootDispatch } = useRoot();

  const flyToDefaultView = () => {
    if (mapContext) {
      mapContext.flyToBounds([
        [52.696361078274485, -53.349609375],
        [52.696361078274485, -137.724609375],
        [23.200960808078566, -53.349609375],
        [23.200960808078566, -137.724609375]
      ], { duration: 2 });
      rootDispatch({
        type: "setIsMapMoving",
        data: true
      })
      mapContext.once("moveend", () => {
        rootDispatch({
          type: "setIsMapMoving",
          data: false
        })
        rootDispatch({
          type: "setDataList",
          data: []
        });
        rootDispatch({
          type: "setDataMarkers",
          data: []
        });
        rootDispatch({
          type: "setExtraMarker",
          data: null,
          mapContext
        });
        mapRefresh({ myLocation: true });
      })
    }
  }

  return {
    flyToDefaultView,
  };
};
